export default __webpack_public_path__ + "static/media/iPhone_schedule.96003a1a.svg";